export default {"src":"/_next/static/media/linkedin.580dbdb2.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};